import "date-fns";
//import DateFnsUtils from "@date-io/date-fns";
//import {MuiPickersUtilsProvider,KeyboardDatePicker} from "@material-ui/pickers";
import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styled from "styled-components";

const Styles = styled.div`

 .react-datepicker__close-icon::before,
 .react-datepicker__close-icon::after {
   background-color: red;
 }
`;
const CustomDatePicker = ({ onChange,value }) => {
  const [fromdate, setFromDate] = useState(null);
  const getFromDate = (event) => {
    let frDate = event.getFullYear() + "-" + (event.getMonth() + 1) + "-" + event.getDate();
    setFromDate(frDate);
    // props.onFilterChanged(props.columnDef.tableData.id, frDate);
  }

  return (
    <DatePicker
      isClearable
      filterDate={d => {
        return new Date() < d;
      }}
      onChange={onChange}
      value={value}
      placeholderText="From Date"
      dateFormat="dd/MM/yyyy"
      className="form-control"
      dropdownMode="select"
      inlineFocusSelectedMonth
    />
  );

};
export default CustomDatePicker;
